var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateMembership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 94,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M114.666 58.115c-7.151 1.15-15.158.104-20.76-3.142-5.601-3.245-7.42-7.854-5.422-11.981l-3.927-2.267L27.41 73.72l1.13 2.26s9.598-5.12 23.536 3.142c5.588 3.307 7.434 7.855 5.436 11.982l1.144 2.267h2.756l57.139-32.997-3.886-2.26z",
    fill: "url(#update-membership_svg__paint0_linear_33134_63673)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.315 77.518c-5.616-3.246-13.608-4.293-20.774-3.108v1.606c7.145-1.151 15.158-.104 20.753 3.141 3.803 2.191 5.857 5.01 6.201 7.876.372-3.438-1.674-6.918-6.18-9.515z",
    fill: "#DC4017"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.137 53.368c-5.622-3.245-7.434-7.855-5.443-11.982l-3.92-2.267-57.14 32.99 3.907 2.301c7.152-1.15 15.158-.103 20.76 3.142 5.601 3.245 7.427 7.855 5.436 11.982l3.92 2.267 57.147-32.99-3.893-2.315c-7.166 1.164-15.158.117-20.774-3.128z",
    fill: "#E95832"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.22 49.02l1.041-.606-2.294-1.323-1.04.6 2.294 1.33zM73.182 51.308l1.048-.6-2.295-1.322-1.04.599 2.287 1.323zM77.157 53.602l1.04-.606-2.294-1.323-1.04.6 2.294 1.33zM81.126 55.89l1.04-.6-2.294-1.323-1.04.6 2.294 1.323zM85.094 58.184l1.04-.606-2.294-1.323-1.04.606 2.294 1.323zM89.063 60.472l1.04-.6-2.294-1.323-1.04.6 2.294 1.323zM93.025 62.766l1.047-.6-2.294-1.33-1.04.607 2.287 1.323zM97 65.06l1.04-.606-2.294-1.323-1.04.6L97 65.06zM100.97 67.348l1.04-.6-2.294-1.33-1.04.607 2.294 1.323z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.048 57.413l8.571-4.954-2.694-1.558-8.578 4.954 2.7 1.558zM55.246 60.761l4.162-2.405-2.701-1.557-4.155 2.405 2.694 1.557zM50.788 63.331l2.508-1.447-2.7-1.557-2.509 1.447 2.701 1.557zM46.055 66.066l2.508-1.447-2.7-1.557-2.509 1.447 2.701 1.557z",
    fill: "#ED795A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.517 65.398a7.78 7.78 0 00-7.062 0c-1.95 1.123-1.95 2.949 0 4.072a7.78 7.78 0 007.062 0c1.943-1.123 1.943-2.949 0-4.072zm-5.739 3.314c-1.22-.689-1.22-1.853 0-2.556a4.906 4.906 0 014.423 0c1.22.689 1.22 1.853 0 2.556a4.893 4.893 0 01-4.423 0zm16.054-3.314c-1.95 1.123-1.95 2.949 0 4.072a7.8 7.8 0 007.062 0c1.943-1.123 1.943-2.949 0-4.072a7.78 7.78 0 00-7.062 0zm5.74 3.314a4.892 4.892 0 01-4.417 0c-1.22-.689-1.22-1.846 0-2.556a4.892 4.892 0 014.416 0c1.22.675 1.22 1.853 0 2.556zm-11.824-7.53v12.54h1.874v-12.54h-1.874z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.97 67.348L58.672 91.766v1.606l42.298-24.419v-1.605z",
    fill: "#DC4017"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.555 74.376l-3.92-2.267v1.606l3.92 2.266v-1.605z",
    fill: "#B83614"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.818 58.777l-13.808 7.972v1.605l13.808-7.979v-1.598z",
    fill: "#DC4017"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M105.769 18.999L73.785 10.31c-4.175-1.547-8.013-2.483-10.29-2.795C56.656 6.572 7.344 43.923.062 56.244v1.85c0 1.88 7.47 8.445 15.306 12.62a23.24 23.24 0 004.311 1.784l-.012.018 41.175 11.276c5.766 1.74 10.119.373 11.962-.221 14.464-6.646 36.448-30.1 36.448-30.1l12.962-9.74 1.538-2.051c2.101-13.51-9.548-21.159-17.982-22.681z",
    fill: "url(#update-membership_svg__paint1_linear_33134_63673)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.897 42.843c-.342.198-.899.197-1.241 0-.343-.197-.347-.52-.005-.718.342-.198.9-.196 1.242 0 .342.197.347.52.004.718z",
    fill: "#E4E4E4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.265 26.973l.966 5.638 5.345 1.523-1.032-5.674-1.314-4.265-3.965 2.778z",
    fill: "#636363"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.968 68.577c-1.877.201-6.322-.44-14.136-6.267C2.198 58.108.543 54.35.061 52.58v3.725c1.767 2.583 4.64 5.924 7.238 7.817 6.197 4.517 11.953 5.954 14.483 6.479 2.53.525 2.234-2.243.186-2.024z",
    fill: "#3E3E3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.549 32.14s-5.42-2.421-5.396-4.286c.025-1.866 3.54.407 4.126.892.587.485 1.148 2.2 1.148 2.2l.39.275v1.099l-.268-.18z",
    fill: "url(#update-membership_svg__paint2_linear_33134_63673)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.008 29.423l-.022-.013c-1.222-.698-3.017-.547-5.021.609-3.671 2.12-6.647 6.813-6.647 10.484 0 1.644.597 2.803 1.586 3.392l.022.014.022.012 3.54 2.063 8.274-5.305 1.454-9.37-3.208-1.886z",
    fill: "#2B2B2B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.699 31.52c-.024.01-.047.02-.072.027-.389.139-.794.206-1.202.27-.394.06-.778.141-1.165.234-.658.158-1.327.285-1.96.529l-.069.033c-.077.08-.163.153-.255.216-.443.31-.888.618-1.341.913-.23.149-.463.294-.698.435-.17.101-.344.193-.508.302a2.8 2.8 0 00-.27.28c-.176.244-.332.504-.5.755-.034.05-.071.098-.112.144-.162.315-.315.636-.459.962-.184.42-.424.81-.616 1.226-.045.12-.081.242-.108.368-.024.24-.04.482-.068.724l.016-.12c-.096.86-.279 1.704-.405 2.559a12.79 12.79 0 00-.038.352c-.028.306-.116.554-.324.781a1.04 1.04 0 01-.608.305c.81 1.874 3.037 2.27 5.655.76 3.304-1.909 5.983-6.135 5.983-9.44 0-1.144-.32-2.027-.876-2.614zm-1.519 5.512a8.082 8.082 0 01-.834 1.72c-.355.56-.77 1.08-1.238 1.55a7.378 7.378 0 01-1.516 1.18c-.526.304-1.036.496-1.515.57-.464.072-.88.031-1.238-.12a1.7 1.7 0 01-.835-.756c-.203-.363-.306-.813-.306-1.339a5.29 5.29 0 01.306-1.692c.21-.604.49-1.182.835-1.72.354-.56.77-1.08 1.238-1.55a7.398 7.398 0 011.515-1.18c.526-.304 1.036-.495 1.516-.57.463-.071.88-.03 1.238.12.356.15.65.417.834.756.203.363.306.81.306 1.34a5.285 5.285 0 01-.306 1.691z",
    fill: "url(#update-membership_svg__paint3_linear_33134_63673)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.39 33.646c.678-.392 1.335-.639 1.953-.734.281-.045.568-.055.852-.03.256.024.506.086.743.185.225.094.433.226.614.39.185.168.341.365.463.584.261.467.393 1.048.393 1.728 0 .68-.132 1.412-.393 2.18-.131.382-.285.756-.463 1.119-.184.377-.389.744-.614 1.098a11.553 11.553 0 01-1.595 1.998 9.525 9.525 0 01-1.953 1.52c-.678.392-1.335.639-1.953.735a3.41 3.41 0 01-.852.029 2.542 2.542 0 01-.744-.184 2.175 2.175 0 01-.613-.39 2.295 2.295 0 01-.463-.585c-.261-.467-.393-1.047-.393-1.727 0-.68.132-1.412.393-2.18.131-.383.285-.756.463-1.12.183-.377.388-.743.613-1.097a11.586 11.586 0 011.596-1.998 9.501 9.501 0 011.953-1.52zm0-1.628c-3.671 2.119-6.647 6.813-6.647 10.483 0 3.671 2.976 4.93 6.647 2.808 3.67-2.121 6.647-6.814 6.647-10.484 0-3.671-2.976-4.929-6.647-2.808z",
    fill: "#3E3E3E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.39 34.467c.567-.327 1.116-.534 1.633-.613.499-.077.948-.034 1.334.129.383.162.7.449.9.815.215.39.328.875.328 1.442s-.11 1.18-.329 1.823a8.74 8.74 0 01-.901 1.857 9.74 9.74 0 01-1.335 1.67 7.923 7.923 0 01-1.632 1.271c-.567.328-1.116.535-1.633.614-.5.077-.948.034-1.334-.13a1.831 1.831 0 01-.9-.814c-.215-.39-.329-.876-.329-1.442 0-.567.108-1.18.33-1.823a8.718 8.718 0 01.9-1.854 9.74 9.74 0 011.333-1.669 7.929 7.929 0 011.633-1.272l.002-.004zm0-.857c-2.79 1.61-5.052 5.18-5.052 7.97s2.261 3.746 5.052 2.135c2.79-1.61 5.052-5.18 5.052-7.97S90.18 32 87.39 33.61z",
    fill: "url(#update-membership_svg__paint4_linear_33134_63673)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.486 39.704a8.703 8.703 0 01-.64.932c-.228.3-.475.583-.74.85 0 0 .416-.418.04-.728-.377-.31-1.124-.594-1.124-.594l1.07-1.381s.347.615.812.997c.465.382.582-.076.582-.076z",
    fill: "url(#update-membership_svg__paint5_linear_33134_63673)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.714 43.443a2.529 2.529 0 01-.739.003c-.419-.057-.64-.193-.64-.193s1.6-.659 1.977-1.404c.376-.745.813-1.936.813-1.936l1.07.147a20.41 20.41 0 00-1.124 1.893c-.465.921-1.357 1.49-1.357 1.49z",
    fill: "url(#update-membership_svg__paint6_linear_33134_63673)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.195 40.679c.036-.66.203-1.306.49-1.9 0 0 1.6.621 2.22.448.621-.172 1.653-.658 1.653-.658l-.379 1.476a7.118 7.118 0 00-1.542.231c-.764.213-2.442.403-2.442.403z",
    fill: "url(#update-membership_svg__paint7_linear_33134_63673)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 35.147c.265-.223.547-.426.843-.606.27-.172.554-.32.85-.44 0 0 .358 1.7.384 2.332.026.632.257 1.512.257 1.512l-1.313.81s.156-.964.124-1.744-1.145-1.864-1.145-1.864z",
    fill: "url(#update-membership_svg__paint8_linear_33134_63673)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.93 34.324s.201.162.387.536c.11.217.187.45.227.69 0 0-.39 1.112-.994 1.695-.604.582-1.485 1.637-1.485 1.637l-.475-.95a18.021 18.021 0 001.62-1.362c.748-.72.72-2.246.72-2.246z",
    fill: "url(#update-membership_svg__paint9_linear_33134_63673)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.497 38.32c0 .779-.631 1.774-1.41 2.223-.778.45-1.409.183-1.409-.594 0-.776.63-1.773 1.41-2.222.778-.45 1.409-.182 1.409.594z",
    fill: "url(#update-membership_svg__paint10_linear_33134_63673)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.734 40.142a.553.553 0 01-.277-.07c-.173-.101-.27-.29-.27-.531 0-.458.353-1.02.802-1.28.266-.154.532-.178.727-.064.174.1.27.289.27.53 0 .458-.352 1.02-.801 1.28a.914.914 0 01-.45.135zm.702-1.626a.526.526 0 00-.253.083c-.33.19-.607.62-.607.942 0 .054.01.155.074.192.054.032.172.032.338-.063.329-.19.606-.622.606-.942 0-.054-.009-.157-.073-.194a.17.17 0 00-.083-.017l-.002-.001z",
    fill: "url(#update-membership_svg__paint11_linear_33134_63673)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.745 42.502c0-3.672 2.975-8.365 6.646-10.485 1.209-.697 2.342-1.029 3.318-1.029a3.468 3.468 0 011.509.32l-1.042-.612a4.392 4.392 0 00-.467-.025c-1.06 0-2.262.371-3.476 1.073-1.819 1.05-3.527 2.742-4.809 4.764-1.287 2.03-1.998 4.157-1.998 5.993 0 1.08.25 2.002.726 2.703l1.07.624c-.924-.608-1.477-1.742-1.477-3.327z",
    fill: "#E4E4E4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.929 63.17l-3.664-2.166s-3.848-1.458-8.836 3.857c-6.115 6.516-3.566-4.523-3.566-4.523l8.35-6.704 8.885 1.22.782 4.639-1.951 3.677z",
    fill: "#3E3E3E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.545 60.471a.452.452 0 00-.07-.04c-.17-.08-.397-.057-.648.086-.53.306-.96 1.048-.96 1.657 0 .336.13.56.337.644l6.857 4 1.35-2.348-6.866-3.999z",
    fill: "url(#update-membership_svg__paint12_linear_33134_63673)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.67 65.074c0 .609-.431 1.35-.96 1.657-.529.307-.96.06-.96-.548 0-.608.431-1.35.96-1.657.529-.308.96-.061.96.548z",
    fill: "#3E3E3E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.864 62.895a.977.977 0 00-.152-.089c-.371-.172-.864-.123-1.404.189-1.152.665-2.086 2.276-2.086 3.597 0 .729.285 1.217.732 1.397l.51.324 2.929-5.098-.53-.32z",
    fill: "url(#update-membership_svg__paint13_linear_33134_63673)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.96 64.527c0 1.322-.934 2.932-2.086 3.597-1.152.666-2.086.133-2.086-1.187s.934-2.933 2.086-3.598c1.152-.665 2.086-.134 2.086 1.188z",
    fill: "url(#update-membership_svg__paint14_linear_33134_63673)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.748 65.226c0 .555-.391 1.23-.874 1.509-.482.279-.874.054-.874-.5 0-.552.391-1.228.874-1.507.483-.279.874-.056.874.498zm.45-1.475a.552.552 0 01-.25.432c-.139.08-.25.016-.25-.142a.552.552 0 01.25-.432c.137-.08.25-.017.25.142zm-1.978 3.672a.551.551 0 01-.25.431c-.138.08-.25.016-.25-.142a.551.551 0 01.25-.432c.138-.08.25-.016.25.142z",
    fill: "#3E3E3E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M.061 58.093v-7.59s-.878-5.2 4.028-9.449c4.907-4.249 10.912-8.202 13.402-10.546 2.49-2.343 9.372-10.912 12.45-13.255C33.017 14.91 54.986 1.8 58.135 1.507c3.15-.293 6.81 1.465 8.568.806a10.457 10.457 0 002.93-1.685s6.517.147 13.695 5.2c7.177 5.053 9.666 6.957 9.74 12.526v12.01l-1.538 2.052s.146-5.831-5.86-1.525c-6.005 4.306-6.664 9.58-7.103 11.265-2.637 1.318-34.64 21.018-34.64 21.018s2.052-7.69-2.343-6.518c-4.395 1.172-10.033 4.028-10.033 15.599-2.27.732-8.349 2.636-16.185-1.538C7.531 66.542.061 59.974.061 58.093z",
    fill: "url(#update-membership_svg__paint15_linear_33134_63673)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.39 65.731c.972.284 1.938.526 2.91.722.967.2 1.944.336 2.928.408l.367.022c.122.007.245.007.367.01.061 0 .122.006.184.007h.183c.122 0 .245 0 .367-.004.49-.01.977-.048 1.463-.111l.364-.054c.12-.02.24-.047.362-.068.06-.011.121-.02.181-.034l.18-.043.18-.042c.06-.013.12-.028.18-.045.482-.132.956-.29 1.422-.473a6.36 6.36 0 01-.633.424l-.166.097c-.054.031-.108.064-.168.091l-.347.167c-.057.029-.117.054-.176.075l-.18.072-.179.07c-.06.023-.122.04-.183.061-.122.04-.245.08-.368.116l-.375.096c-.125.033-.252.053-.378.079a5.124 5.124 0 01-.382.064c-.127.016-.254.037-.383.05l-.385.033c-.128.014-.257.012-.385.018l-.194.007h-.192c-.129 0-.258 0-.386-.008l-.385-.019a13.573 13.573 0 01-3.01-.565c-.486-.149-.964-.324-1.432-.524a12.47 12.47 0 01-.689-.324 7.482 7.482 0 01-.662-.375z",
    fill: "#3E3E3E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.359 43.483l-.193-.03c.006-.038.609-3.836 1.481-7.052.83-3.06 3.422-5.369 3.734-5.637.196-1.89-.323-5.925-.365-6.216l-3.78-7.439.173-.088 3.797 7.47v.016c.006.043.58 4.363.364 6.316l-.004.04-.03.025c-.028.023-2.838 2.384-3.701 5.564-.87 3.207-1.47 6.995-1.476 7.032zM68.882 1.56c.553.01 1.105.054 1.656.112.274.035.55.065.822.112l.411.066c.136.023.27.054.409.077a23.55 23.55 0 013.21.87 24.85 24.85 0 013.068 1.291c.125.062.25.12.374.185l.366.198.366.199c.122.066.245.131.363.204l.716.426.179.108.174.113.35.228c1.843 1.232 3.62 2.564 5.258 4.06.82.749 1.59 1.548 2.308 2.395l.265.32c.086.108.168.22.253.33.172.217.328.448.486.676.078.114.15.234.224.35.074.117.142.239.21.36.138.24.256.49.353.75a5.041 5.041 0 00-.395-.726c-.075-.116-.147-.233-.228-.345-.08-.11-.155-.227-.239-.336l-.25-.328c-.081-.111-.174-.216-.26-.32a19.492 19.492 0 00-.265-.318l-.276-.307c-.093-.101-.181-.207-.276-.306l-.287-.298-.286-.296-.297-.287-.297-.286-.148-.144-.153-.138-.613-.553c-.206-.183-.42-.356-.63-.534-.21-.178-.417-.359-.635-.527-.432-.34-.858-.69-1.305-1.012l-.662-.494c-.108-.084-.221-.162-.334-.242l-.339-.237-.676-.475-.169-.118-.173-.113-.345-.225-.344-.226-.172-.113-.177-.108-.707-.427c-.116-.072-.238-.137-.358-.203l-.361-.198-.361-.198c-.122-.065-.245-.125-.368-.187-.246-.122-.485-.251-.737-.368l-.75-.343c-.25-.112-.506-.21-.76-.318-.253-.108-.51-.201-.767-.3a26.074 26.074 0 00-3.157-.953l-.403-.094-.404-.082c-.27-.058-.54-.097-.814-.147a24.224 24.224 0 00-1.643-.2z",
    fill: "#3E3E3E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M93.068 18.35a17.289 17.289 0 00-.024-.722c-.224.688-.653 1.365-1.372 1.995-3.923 3.433-4.761 3.563-4.761 3.563s3.121.797 6.154-1.046l.003-3.79z",
    fill: "#3E3E3E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.41 36.061s-5.867 7.413-6.088 11.202c0-1.093 1.543-6.616 5.907-11.774a.99.99 0 00.182.572zm2.945 16.202s9.923-.486 15.61-5.621l.1.914s-7.052 5.083-15.71 4.707z",
    fill: "#3E3E3E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.148 49.75a.569.569 0 01-.359-.119c-.24-.188-.318-.582-.19-.957 1.661-4.84 3.88-9.512 6.419-13.51 4.326-6.814 9.488-11.638 15.342-14.339 13.731-6.334 20.671-3.89 22.952-3.087a.756.756 0 01.18 1.33c-.357.277-26.362 20.286-43.752 30.475-.242.155-.438.207-.592.207zm37.495-32.956c-3.747 0-9.044.907-16.201 4.208C52.422 27.01 45.958 42.4 43.784 48.737c-.1.293-.047.605.126.74.165.131.424.095.728-.1 17.416-10.204 43.476-30.263 43.738-30.464a.554.554 0 00.239-.54.548.548 0 00-.368-.451c-1.078-.38-3.2-1.128-6.604-1.128z",
    fill: "#3E3E3E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.85 19.62S62.914 37.308 47.445 46.371c-.735.471-1.058-.132-.876-.661 1.569-4.573 6.945-17.55 18.924-23.076 11.824-5.453 18.042-4.8 20.223-4.033a.576.576 0 01.136 1.02zm-55.468-1.182l-10.97 11.461a3.804 3.804 0 00.167 5.425c5.093 4.705 16.467 10.07 18.213 10.393 2.547.47 4.384-.529 5.33-2.009l7.88-12.337a.833.833 0 00-.325-1.188c-3.23-1.641-15.089-7.8-19.109-11.761a.83.83 0 00-1.186.016z",
    fill: "#3E3E3E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.984 18.644c.097 0 .19.039.258.108 4.037 3.978 15.735 10.07 19.224 11.844a.369.369 0 01.144.528l-7.883 12.337a4.062 4.062 0 01-1.457 1.368c-.657.361-1.413.545-2.246.545a6.35 6.35 0 01-1.151-.108c-1.628-.301-12.914-5.595-17.983-10.278a3.34 3.34 0 01-.146-4.765l10.973-11.467a.369.369 0 01.27-.114l-.003.002zm0-.463a.83.83 0 00-.602.257l-10.97 11.461a3.804 3.804 0 00.167 5.425c5.093 4.705 16.467 10.07 18.213 10.393.407.077.82.116 1.235.117 1.91 0 3.309-.897 4.094-2.126l7.88-12.337a.833.833 0 00-.324-1.188c-3.23-1.641-15.089-7.8-19.109-11.761a.827.827 0 00-.582-.239l-.002-.002z",
    fill: "#343434"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.323 2.236l6.7.842c.054.007.103.012.155.016 1.023.082 12.772 1.208 19.097 10.127.494.698-.028 1.662-.883 1.634a139.99 139.99 0 01-5.578-.315 2.327 2.327 0 01-1.483-.685c-1.75-1.77-7.531-7.024-18.124-11.163-.26-.102-.161-.491.116-.456z",
    fill: "#3E3E3E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.457 60.966s.319-1.013 1.523-1.776c1.205-.764 10-1.336 10-1.336 1.148-.143 1.906 1.16 1.215 2.086l-.924 1.237c-1.188 1.59-2.683 2.194-5.242 2.273-2.558.079-5.957-1.3-5.957-1.3a.84.84 0 01-.615-1.184z",
    fill: "#fff",
    opacity: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.833 57.353c1.047 0 1.696 1.218 1.04 2.097l-.924 1.237c-1.188 1.59-2.683 2.194-5.242 2.273-.07 0-.143.003-.216.003-2.529 0-5.742-1.302-5.742-1.302a.84.84 0 01-.614-1.188s.318-1.013 1.523-1.776c1.204-.764 10-1.336 10-1.336.058-.007.116-.01.174-.01v.002zm0-.293c-.067 0-.134.004-.201.012-.151.01-2.295.153-4.551.382-1.37.14-2.513.282-3.398.425-1.538.25-1.982.446-2.181.573-1.2.76-1.583 1.755-1.639 1.915a1.133 1.133 0 00.805 1.577c.34.135 3.362 1.311 5.825 1.311.075 0 .15 0 .224-.003 1.361-.041 2.391-.23 3.239-.594.886-.377 1.594-.949 2.227-1.797l.922-1.235a1.605 1.605 0 00-1.275-2.564l.003-.002z",
    fill: "#3E3E3E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.133 60.476s.319-1.013 1.523-1.777c1.204-.763 10-1.335 10-1.335 1.147-.143 1.905 1.16 1.214 2.086l-.924 1.237c-1.187 1.59-2.683 2.194-5.241 2.273-2.559.078-5.958-1.3-5.958-1.3a.839.839 0 01-.614-1.184z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M.32 47.003a7.533 7.533 0 00-.04.165l.04-.165zm.047-.18c-.015.054-.029.111-.043.167.014-.056.03-.11.043-.167zm.051-.181l-.047.168c.015-.056.03-.112.047-.168zm-.14.537z",
    fill: "#3E3E3E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28 41.823l-.103.098C.85 44.351.193 46.953.04 48.646c.972 1.919 2.756 3.718 2.756 3.718a.84.84 0 001.333.085s.054-1.391-.147-3.485c-.158-1.633-.542-5.513-.703-7.141z",
    fill: "#fff",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M3.961 41.403l-.02-.216c-1.364 1.215-2.265 2.502-2.855 3.718.55-1.134 1.37-2.33 2.584-3.471.162 1.628.544 5.507.702 7.141.203 2.093.146 3.484.146 3.484a.84.84 0 01-1.332-.084S1.033 49.805.17 47.69l.031-.166c-.048.244-.086.477-.115.701.918 1.914 2.658 3.72 2.872 3.942a1.134 1.134 0 001.782.089l.067-.078.004-.103c.003-.057.054-1.435-.148-3.524a3698.5 3698.5 0 00-.703-7.148z",
    fill: "#3E3E3E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M.24 47.352zm.426-1.462a8.15 8.15 0 00-.064.18l.064-.18zm.42-.984l-.093.195c.03-.065.063-.13.092-.195zm-.346.791l-.07.182.07-.182zm-.207.573a7.775 7.775 0 00-.054.173l.054-.172z",
    fill: "#3E3E3E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67 41.432C1.383 43.582.494 45.923.17 47.689c.864 2.115 3.016 4.284 3.016 4.284a.839.839 0 001.332.085s.054-1.391-.147-3.484a4445.85 4445.85 0 00-.703-7.142z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.232 64.667l-9.227-5.328v-2.392l9.227 5.328v2.392z",
    fill: "#fff",
    opacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.04 18.559c1.875 0 3.012.302 3.523.481a.108.108 0 01.074.092.107.107 0 01-.049.11l-.008.007-.01.007c-.057.044-5.818 4.481-13.393 9.97-6.988 5.062-16.99 12.076-24.964 16.749l-.008.004-.008.005a.616.616 0 01-.205.094.374.374 0 01.015-.216c.756-2.21 2.484-6.587 5.507-11.072 3.672-5.446 8.105-9.394 13.174-11.734 8.06-3.718 13.34-4.498 16.352-4.498zm0-.463c-3.37 0-8.735.937-16.546 4.54-11.981 5.527-17.36 18.503-18.925 23.076-.136.395.01.832.399.832.132 0 .292-.051.478-.17C62.913 37.31 85.85 19.62 85.85 19.62a.578.578 0 00-.136-1.018c-.74-.26-1.944-.509-3.677-.509l.002.003z",
    fill: "#343434"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M80.274 24.506l-3.19-6.72 1.326-.622 3.19 6.72-1.326.622z",
    fill: "url(#update-membership_svg__paint16_linear_33134_63673)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M61.978 2.91l4.987.627a3.8 3.8 0 00.176.018c.581.046 3.671.348 7.438 1.723 2.176.793 4.17 1.8 5.927 2.992 2.16 1.465 3.974 3.22 5.39 5.218a.574.574 0 01-.469.904h-.02c-2.128-.07-4.396-.226-5.561-.314a1.865 1.865 0 01-1.188-.548c-1.893-1.915-7.18-6.636-16.683-10.62h.003zm-1.69-.674c-.25 0-.331.361-.082.458C70.8 6.834 76.581 12.09 78.33 13.857c.396.4.922.643 1.483.685 1.213.091 3.46.245 5.578.315h.036c.835 0 1.335-.946.847-1.635C79.95 4.302 68.201 3.177 67.178 3.095a2.732 2.732 0 01-.155-.016l-6.7-.843h-.035z",
    fill: "#343434"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 68.577c-1.88.201-6.322-.44-14.135-6.267C2.95 59.092.97 56.135.062 54.13v2.981c1.777 2.44 4.334 5.311 6.67 7.013 6.197 4.517 11.953 5.953 14.482 6.478 2.529.526 2.234-2.244.185-2.025z",
    fill: "#fff",
    opacity: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.968 68.577c-1.877.201-6.322-.44-14.136-6.267C2.198 58.108.543 54.35.061 52.58v3.725c1.767 2.583 4.64 5.924 7.238 7.817 6.197 4.517 11.953 5.954 14.483 6.479 2.53.525 2.234-2.243.186-2.024z",
    fill: "#3E3E3E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M65.555 38.626v.732l1.71-.987v.627l1.391-.803v-1.359l-3.1 1.79z",
    fill: "#343434"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.981 62.677c1.267-.324 2.183-.942 2.965-1.99l.924-1.237c.691-.927-.067-2.23-1.214-2.086 0 0-.73.048-1.798.134.517 1.216.735 3.05-.877 5.18z",
    fill: "url(#update-membership_svg__paint17_linear_33134_63673)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M3.821 42.964l-.152-1.532C1.662 43.322.732 45.357.316 47.021c.964-2.756 2.58-3.722 3.505-4.057z",
    fill: "url(#update-membership_svg__paint18_linear_33134_63673)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.356 50.643c-.462-.27-.75-.067-.64.459l.997 4.732c.11.525.579 1.178 1.042 1.45l5.081 2.997c.463.272 1.143.176 1.512-.216l2.183-2.313c.369-.39.292-.934-.17-1.206L6.356 50.643z",
    fill: "#fff",
    opacity: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 50.545c-.462-.273-.75-.066-.64.46l.997 4.73c.108.527.579 1.18 1.042 1.453l5.081 2.995c.463.27 1.143.177 1.512-.216l2.184-2.313c.368-.39.291-.933-.171-1.206L6.6 50.545z",
    fill: "#3E3E3E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M6.932 55.62l.024.116c.016.071.036.141.06.21l7.468 4.12c.038-.03.074-.063.108-.097l.076-.08-7.736-4.269zM15.238 59.285l.173-.183-8.764-4.836.067.316 8.524 4.703zM6.429 53.227l9.552 5.271.173-.184-9.792-5.402.067.315zM6.077 51.558l.067.315 10.582 5.838.054-.054a.906.906 0 00.108-.137l-10.81-5.962z",
    fill: "#2B2B2B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M65.78 21.873l-1.326.622L69.63 33.53l1.326-.622-5.176-11.035z",
    fill: "url(#update-membership_svg__paint19_linear_33134_63673)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.435 18.99S62.309 39.136 44.69 49.46c-.837.535-1.205-.153-.999-.757 1.787-5.208 8.066-21.497 21.71-27.791 13.467-6.213 20.395-3.959 22.878-3.085a.658.658 0 01.156 1.163z",
    fill: "#3E3E3E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35 59.18l8.883 5.128v-2.033L5.35 57.147v2.034z",
    fill: "url(#update-membership_svg__paint20_linear_33134_63673)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.412 65.295C20.806 66.392 6.552 58.454.061 51.66v6.433c0 1.88 7.47 8.446 15.306 12.62 7.836 4.175 13.915 2.27 16.185 1.538 0-5.584 1.313-9.14 3.167-11.454-4.02 2.309-7.443 4.057-9.307 4.498zM91.53 32.412l1.538-2.052v-7.552c-5.727 3.975-28.079 19.45-32.861 22.195-2.92 1.674-10.822 6.886-18.51 11.621 4.246-1.012 2.231 6.546 2.231 6.546s32.004-19.7 34.64-21.018c.439-1.684 1.098-6.957 7.103-11.265 6.006-4.308 5.86 1.525 5.86 1.525z",
    fill: "#3E3E3E",
    opacity: 0.4
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M.786 54.457a11.331 11.331 0 01-.62-1.532l-.102-.06v3.441c.162.236.331.478.51.724-.008-.87.104-1.85.212-2.573z",
    fill: "url(#update-membership_svg__paint21_linear_33134_63673)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M21.968 68.577c-.756.081-1.935.025-3.583-.454-.11.478-.162 1.092.088 1.63 1.37.422 2.503.683 3.309.85 2.529.527 2.234-2.245.186-2.026z",
    fill: "url(#update-membership_svg__paint22_linear_33134_63673)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M50.332 55.218l.493-.355.495-.35.992-.702c.663-.462 1.327-.923 1.993-1.383.665-.46 1.335-.912 2.003-1.37l2.011-1.356 2.02-1.346.506-.334.127-.083.029-.02.032-.023.063-.045c.084-.059.17-.115.256-.17.345-.225.71-.417 1.09-.575.192-.08.39-.145.59-.194.205-.053.417-.075.628-.067.218.008.43.074.613.192.177.125.316.297.4.496.08.192.132.395.153.603.022.203.029.408.021.612-.007.402.009.81-.063 1.212.02-.201.026-.403.016-.605l-.023-.606c-.002-.2-.019-.4-.05-.599a2.024 2.024 0 00-.171-.562 1.027 1.027 0 00-.366-.424 1.043 1.043 0 00-.537-.145c-.194 0-.387.026-.574.078-.19.052-.376.118-.556.2a7.248 7.248 0 00-1.288.749l-.06.043-.03.023-.033.023-.125.085-.501.342-2.013 1.358-2.024 1.346c-.676.444-1.35.893-2.029 1.334-.679.44-1.357.882-2.038 1.32l-1.026.651-.512.324-.512.323z",
    fill: "#3E3E3E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M46.302 61.71c.726-3.352.772-8.447-6.77-5.716-9.204 3.334-9.402 13.615-9.252 16.644.504-.138.931-.275 1.272-.384 0-11.571 5.639-14.427 10.033-15.599 4.394-1.171 2.344 6.518 2.344 6.518s.885-.548 2.373-1.463z",
    fill: "url(#update-membership_svg__paint23_linear_33134_63673)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M77.269 42.88a29.723 29.723 0 011.3-.728c.438-1.684 1.097-6.957 7.103-11.265 6.005-4.308 5.859 1.525 5.859 1.525l1.385-1.847c-.557-3.014-2.65-4.094-8.27-.858-5.238 3.016-6.928 10.483-7.377 13.173z",
    fill: "url(#update-membership_svg__paint24_linear_33134_63673)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M46.148 46.787s5.42 3.837 5.395 1.944c-.024-1.894-3.54-3.68-4.126-3.871-.586-.192-1.147.875-1.147.875l-.39-.177v1.099l.268.13z",
    fill: "#636363"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M91.699 31.52c-.024.01-.047.02-.072.027-.389.139-.794.206-1.202.27-.394.06-.778.141-1.165.234-.658.158-1.327.285-1.96.529l-.069.033c-.077.08-.163.153-.255.216-.443.31-.888.618-1.341.913-.23.149-.463.294-.698.435-.17.101-.344.193-.508.302a2.8 2.8 0 00-.27.28c-.176.244-.332.504-.5.755-.034.05-.071.098-.112.144-.162.315-.315.636-.459.962-.184.42-.424.81-.616 1.226-.045.12-.081.242-.108.368-.024.24-.04.482-.068.724l.016-.12c-.096.86-.279 1.704-.405 2.559a12.79 12.79 0 00-.038.352c-.028.306-.116.554-.324.781a1.04 1.04 0 01-.608.305c.81 1.874 3.037 2.27 5.655.76 3.304-1.909 5.983-6.135 5.983-9.44 0-1.144-.32-2.027-.876-2.614zm-1.519 5.512a8.082 8.082 0 01-.834 1.72c-.355.56-.77 1.08-1.238 1.55a7.378 7.378 0 01-1.516 1.18c-.526.304-1.036.496-1.515.57-.464.072-.88.031-1.238-.12a1.7 1.7 0 01-.835-.756c-.203-.363-.306-.813-.306-1.339a5.29 5.29 0 01.306-1.692c.21-.604.49-1.182.835-1.72.354-.56.77-1.08 1.238-1.55a7.398 7.398 0 011.515-1.18c.526-.304 1.036-.495 1.516-.57.463-.071.88-.03 1.238.12.356.15.65.417.834.756.203.363.306.81.306 1.34a5.285 5.285 0 01-.306 1.691z",
    fill: "url(#update-membership_svg__paint25_linear_33134_63673)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M87.39 33.646c.678-.392 1.335-.639 1.953-.734.281-.045.568-.055.852-.03.256.024.506.086.743.185.225.094.433.226.614.39.185.168.341.365.463.584.261.467.393 1.048.393 1.728 0 .68-.132 1.412-.393 2.18-.131.382-.285.756-.463 1.119-.184.377-.389.744-.614 1.098a11.553 11.553 0 01-1.595 1.998 9.525 9.525 0 01-1.953 1.52c-.678.392-1.335.639-1.953.735a3.41 3.41 0 01-.852.029 2.542 2.542 0 01-.744-.184 2.175 2.175 0 01-.613-.39 2.295 2.295 0 01-.463-.585c-.261-.467-.393-1.047-.393-1.727 0-.68.132-1.412.393-2.18.131-.383.285-.756.463-1.12.183-.377.388-.743.613-1.097a11.586 11.586 0 011.596-1.998 9.501 9.501 0 011.953-1.52zm0-1.628c-3.671 2.119-6.647 6.813-6.647 10.483 0 3.671 2.976 4.93 6.647 2.808 3.67-2.121 6.647-6.814 6.647-10.484 0-3.671-2.976-4.929-6.647-2.808z",
    fill: "#3E3E3E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M85.614 43.444a2.672 2.672 0 01-.744 0 2.836 2.836 0 01-.732-.204s1.72-.712 2.096-1.458c.376-.746.814-1.936.814-1.936l1.069.147c-.408.61-.784 1.243-1.124 1.894-.465.92-1.379 1.557-1.379 1.557z",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M83.195 40.563c.036-.66.203-1.305.49-1.9 0 0 1.6.622 2.22.449.621-.174 1.653-.66 1.653-.66l-.379 1.477a7.142 7.142 0 00-1.542.23c-.764.215-2.442.404-2.442.404z",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M86.282 35.18c.266-.224.547-.426.844-.607.269-.172.553-.32.85-.439 0 0 .357 1.7.383 2.331.026.633.257 1.512.257 1.512l-1.313.81s.155-.963.123-1.744c-.032-.782-1.144-1.864-1.144-1.864z",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M90.798 34.192s.2.162.387.536c.11.217.187.45.227.69 0 0-.391 1.112-.995 1.694-.603.583-1.484 1.638-1.484 1.638l-.476-.951a18.036 18.036 0 001.623-1.362c.745-.72.718-2.245.718-2.245zm-.312 5.821s-.353.08-.772.622a9.87 9.87 0 00-.695 1.026s.37-.594-.006-.902c-.376-.307-1.124-.594-1.124-.594l1.07-1.381s.348.615.813.997c.465.382.714.232.714.232zm-6.648-2.48c-.094.32-.18.64-.264.963.182-.412.394-.811.636-1.193a2.374 2.374 0 01-.372.23z",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M91.887 33.952a2.417 2.417 0 01-1.014-.025 3.23 3.23 0 01-.756-.317c-.294.01-.586.046-.88.054-.352.005-.7-.036-1.05-.038-.422.208-.832.4-1.295.486-.048.192-.121.378-.216.552.168-.117.338-.227.51-.326.567-.327 1.117-.534 1.633-.614.5-.077.948-.033 1.334.13.385.16.704.447.904.813.216.39.329.876.329 1.443 0 .567-.108 1.18-.33 1.823a8.713 8.713 0 01-.899 1.853 9.715 9.715 0 01-1.333 1.67 7.926 7.926 0 01-1.633 1.271c-.567.328-1.117.534-1.633.614-.5.077-.948.033-1.334-.13a1.829 1.829 0 01-.9-.814c-.215-.39-.328-.876-.328-1.443 0-.233.019-.466.053-.696-.065.224-.124.449-.17.68-.02.264-.021.528-.005.792.063.312.148.619.255.918.06.122.127.24.2.355.225.35.337.762.32 1.179.912.37 2.16.202 3.543-.594 2.79-1.611 5.052-5.18 5.052-7.97 0-.665-.126-1.22-.357-1.666z",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M87.39 34.467c.567-.327 1.116-.534 1.633-.613.499-.077.948-.034 1.334.129.383.162.7.449.9.815.215.39.328.875.328 1.442s-.11 1.18-.329 1.823a8.74 8.74 0 01-.901 1.857 9.74 9.74 0 01-1.335 1.67 7.923 7.923 0 01-1.632 1.271c-.567.328-1.116.535-1.633.614-.5.077-.948.034-1.334-.13a1.831 1.831 0 01-.9-.814c-.215-.39-.329-.876-.329-1.442 0-.567.108-1.18.33-1.823a8.718 8.718 0 01.9-1.854 9.74 9.74 0 011.333-1.669 7.929 7.929 0 011.633-1.272l.002-.004zm0-.857c-2.79 1.61-5.052 5.18-5.052 7.97s2.261 3.746 5.052 2.135c2.79-1.61 5.052-5.18 5.052-7.97S90.18 32 87.39 33.61z",
    fill: "url(#update-membership_svg__paint26_linear_33134_63673)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M90.486 39.704c-.178.33-.384.645-.617.938a7.847 7.847 0 01-.765.864s.373-.468.041-.747c-.373-.314-1.123-.594-1.123-.594l1.07-1.382s.347.615.812.997c.465.383.582-.076.582-.076z",
    fill: "url(#update-membership_svg__paint27_linear_33134_63673)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M85.691 43.51a2.637 2.637 0 01-.743 0 1.57 1.57 0 01-.658-.228s1.644-.688 2.021-1.432.814-1.936.814-1.936l1.07.147c-.41.61-.784 1.242-1.125 1.894-.465.919-1.379 1.555-1.379 1.555z",
    fill: "url(#update-membership_svg__paint28_linear_33134_63673)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M83.195 40.679c.036-.66.203-1.306.49-1.9 0 0 1.6.621 2.22.448.621-.172 1.653-.658 1.653-.658l-.379 1.476a7.118 7.118 0 00-1.542.231c-.764.213-2.442.403-2.442.403z",
    fill: "url(#update-membership_svg__paint29_linear_33134_63673)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 35.147c.265-.223.547-.426.843-.606.27-.172.554-.32.85-.44 0 0 .358 1.7.384 2.332.026.632.257 1.512.257 1.512l-1.313.81s.156-.964.124-1.744-1.145-1.864-1.145-1.864z",
    fill: "url(#update-membership_svg__paint30_linear_33134_63673)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M90.93 34.324s.201.162.387.536c.11.217.187.45.227.69 0 0-.39 1.112-.994 1.695-.604.582-1.485 1.637-1.485 1.637l-.475-.95a18.021 18.021 0 001.62-1.362c.748-.72.72-2.246.72-2.246z",
    fill: "url(#update-membership_svg__paint31_linear_33134_63673)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M89.364 38.188c0 .778-.63 1.774-1.41 2.223-.778.45-1.408.183-1.408-.594 0-.777.63-1.773 1.409-2.223.778-.449 1.41-.184 1.41.594z",
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M89.497 38.32c0 .779-.631 1.774-1.41 2.223-.778.45-1.409.183-1.409-.594 0-.776.63-1.773 1.41-2.222.778-.45 1.409-.182 1.409.594z",
    fill: "url(#update-membership_svg__paint32_linear_33134_63673)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M87.734 40.013a.425.425 0 01-.215-.054c-.132-.076-.205-.225-.205-.419 0-.41.33-.933.738-1.168.225-.13.443-.154.598-.064.132.076.205.225.205.419 0 .41-.331.934-.738 1.168a.783.783 0 01-.383.118zm.702-1.626a.658.658 0 00-.318.1c-.37.216-.671.686-.671 1.054 0 .144.049.252.138.304.113.066.283.042.467-.064.37-.216.671-.686.671-1.053 0-.145-.049-.254-.139-.305a.293.293 0 00-.145-.036h-.003z",
    fill: "url(#update-membership_svg__paint33_linear_33134_63673)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M80.745 42.502c0-3.672 2.975-8.365 6.646-10.485 1.209-.697 2.342-1.029 3.318-1.029a3.468 3.468 0 011.509.32l-1.042-.612a4.392 4.392 0 00-.467-.025c-1.06 0-2.262.371-3.476 1.073-1.819 1.05-3.527 2.742-4.809 4.764-1.287 2.03-1.998 4.157-1.998 5.993 0 1.08.25 2.002.726 2.703l1.07.624c-.924-.608-1.477-1.742-1.477-3.327z",
    fill: "#885F54"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M71.026 46.669l-.194-.01c.003-.063.333-6.314.333-9.071 0-2.733-.96-4.292-.972-4.307l-.006-.012-5.466-12.034.177-.08 5.464 12.028c.076.123.996 1.673.996 4.405 0 2.764-.332 9.02-.332 9.08z",
    fill: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M59.858 84.138c-.37-.212-.759-.39-1.16-.534l-.014-.005a9.34 9.34 0 00-1.46-.392L44.64 79.824a9.4 9.4 0 00-1.502-.403l-.01-.003c-2.257-.412-4.816-.108-6.597.921-2.55 1.473-2.537 3.867.03 5.349.535.303 1.105.54 1.697.708l.05.015c.094.027.19.054.286.076l13.427 3.598c.33.109.665.199 1.005.27h.01c2.315.486 5.001.195 6.849-.871 2.551-1.471 2.538-3.865-.028-5.346z",
    fill: "url(#update-membership_svg__paint34_linear_33134_63673)"
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M41.548 64.54a.384.384 0 01.04-.113.696.696 0 01-.006-.189c.035-.357.012-1.316-.175-1.283-.115.02-.104.132-.121.253-.166-.457-.432-.859-.855-.831h-.007a.394.394 0 00-.213.066c-.292.185-.182.682.157 1.296.206.386.39.784.552 1.192.265-.05.58-.148.628-.391z",
    fill: "#E6E6E6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M45.676 67.563c-.135.805-.08 1.856-1.35 1.13-1.27-.726-3.188-3.456-3.448-3.796-.26-.34.395-1.06.717-.839.798.546 2.92 2.042 4.202 2.954a2.161 2.161 0 00-.121.55z",
    fill: "url(#update-membership_svg__paint35_linear_33134_63673)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M47.394 61.354c.504.108 1.455.899.178 3.531-1.277 2.632-2.075 4.02-2.372 4.05-.297.029-2.142-.074-1.022-2.65.695-1.6 1.651-5.27 3.216-4.93z",
    fill: "url(#update-membership_svg__paint36_linear_33134_63673)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M40.92 80.574c-.914-.493-2.358-.274-3.163-.237-.804.036-.786.731-.183 1.133.604.403 1.445.677 2.231.972.787.296 1.956.567 1.956-.475 0-1.043-.84-1.393-.84-1.393z",
    fill: "#3D3D3D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M41.642 63.272c1.26-.978 6.403-3.94 6.803-.216.4 3.726-.216 9.3-.15 10.015.064.714-3.078 2.972-6.31 1.572-.059-1.543-2.115-9.996-.343-11.37z",
    fill: "url(#update-membership_svg__paint37_linear_33134_63673)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M42.255 74.948s-1.989-1.856-2.4-.548c-.41 1.308-.46 6.336-.46 6.336s.545 1.188 1.603.562c.132-2.181.728-4.397.728-4.397l.529-1.953z",
    fill: "url(#update-membership_svg__paint38_linear_33134_63673)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M48.47 77.515c-.111 2.468-3.372 2.227-3.372 2.227l-.576 4.657s4.175 2.564 4.743 3.74c-.64.773-1.704.821-1.704.821l-6.093-3.267V71.261l6.832 1.794c.178 1.48.235 2.971.17 4.46z",
    fill: "url(#update-membership_svg__paint39_linear_33134_63673)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M41.13 68.918c.3 2.47.826 4.957.855 5.726 3.23 1.4 6.374-.857 6.309-1.572-.054-.566.324-4.185.283-7.517a1.207 1.207 0 01-.17-.412 7.687 7.687 0 00-1.448-3.881c-.412-.068-.601-.086-1.087.024.18.11.35.234.51.372.27.22.898 1.105.898 3.087-.705.858-2.44.781-2.44.781-.315-2.302-1.084-2.684-1.604-3.253-.233.123-.454.249-.657.37.837.995 1.09 3.18.99 4.234-.09.939-1.728 1.737-2.439 2.041z",
    fill: "url(#update-membership_svg__paint40_linear_33134_63673)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M42.93 61.067a1.006 1.006 0 01.367 1.182c.765.05 1.656.286 2.249-.172.88-.68.362-.648.133-.933-.329-.411-.126-.699-.126-.699l-2.623.622z",
    fill: "#D9D9D9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M41.71 58.08s.274 1.816.605 2.598c.331.782.609 1.026 1.52.585.912-.44 2.379-1.964 1.974-2.649-.405-.684-2.68-2.81-4.099-.534z",
    fill: "#E6E6E6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M41.21 57.978c.125.803.746.993 1.127 1.164l.378.17s.019 1.085.972 1.6c.953.515 1.354.356 1.952-.205.597-.56.768-1.471.492-2.286-.275-.815-.755-2.39-2.442-2.31-1.687.08-2.677.603-2.48 1.867z",
    fill: "#3D3D3D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M42.928 60.158s-.086-.702.328-.545c.414.157.652.788.296 1.075-.355.286-.702.078-.624-.53z",
    fill: "#E6E6E6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M41.872 58.763l-1.626-.804s-1.127-.378-.411-1.304c.715-.925 1.325-.943 1.733-.803.408.14 1.404.354 1.404.354l-1.1 2.557z",
    fill: "url(#update-membership_svg__paint41_linear_33134_63673)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M42.434 59.26c.79.352 1.926.832 3.355-.284 1.26-.983-.257-2.983-1.353-3.155-.67-.105-2.376-.289-3.042 1.193-.665 1.482 1.04 2.245 1.04 2.245z",
    fill: "url(#update-membership_svg__paint42_linear_33134_63673)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M36.543 66.401a.377.377 0 01.04-.112.717.717 0 01-.007-.188c.035-.358.013-1.317-.175-1.284-.115.021-.104.132-.121.253-.166-.456-.432-.859-.854-.83h-.008a.393.393 0 00-.213.065c-.292.186-.181.682.157 1.296.206.387.391.785.552 1.192.267-.047.582-.145.629-.392z",
    fill: "#E6E6E6"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M40.672 69.427c-.135.804-.08 1.856-1.35 1.13-1.27-.725-3.188-3.455-3.447-3.795-.26-.34.394-1.06.717-.84.798.547 2.919 2.042 4.201 2.953a2.16 2.16 0 00-.121.552z",
    fill: "url(#update-membership_svg__paint43_linear_33134_63673)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M42.39 63.218c.504.108 1.455.899.178 3.531-1.277 2.633-2.075 4.02-2.372 4.05-.298.03-2.141-.074-1.022-2.65.696-1.6 1.652-5.269 3.217-4.93z",
    fill: "url(#update-membership_svg__paint44_linear_33134_63673)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M48.116 85.88c-.796-.257-1.796.722-.76 2.457 1.037 1.735 1.923 2.418 2.444 2.285.521-.132.025-2.267-.183-2.688-.208-.421-.593-1.76-1.5-2.053z",
    fill: "#3D3D3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint0_linear_33134_63673",
    x1: 27.411,
    y1: 67.045,
    x2: 118.594,
    y2: 67.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint1_linear_33134_63673",
    x1: 87.016,
    y1: 68.002,
    x2: 59.481,
    y2: 42.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B38F85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint2_linear_33134_63673",
    x1: 16.153,
    y1: 29.724,
    x2: 21.817,
    y2: 29.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint3_linear_33134_63673",
    x1: 72.397,
    y1: 46.256,
    x2: 92.291,
    y2: 46.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint4_linear_33134_63673",
    x1: 83.745,
    y1: 38.312,
    x2: 106.544,
    y2: 40.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint5_linear_33134_63673",
    x1: 83.62,
    y1: 39.603,
    x2: 106.419,
    y2: 41.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint6_linear_33134_63673",
    x1: 83.444,
    y1: 41.43,
    x2: 106.243,
    y2: 43.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint7_linear_33134_63673",
    x1: 83.591,
    y1: 39.452,
    x2: 106.648,
    y2: 41.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint8_linear_33134_63673",
    x1: 83.961,
    y1: 36.061,
    x2: 106.761,
    y2: 38.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint9_linear_33134_63673",
    x1: 83.966,
    y1: 36.021,
    x2: 106.765,
    y2: 38.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint10_linear_33134_63673",
    x1: 88.49,
    y1: 37.292,
    x2: 89.258,
    y2: 40.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint11_linear_33134_63673",
    x1: 88.354,
    y1: 38.084,
    x2: 87.82,
    y2: 40.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint12_linear_33134_63673",
    x1: 29.093,
    y1: 68.203,
    x2: 30.746,
    y2: 66.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint13_linear_33134_63673",
    x1: 36.457,
    y1: 66.102,
    x2: 38.177,
    y2: 62.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint14_linear_33134_63673",
    x1: 34.041,
    y1: 68.483,
    x2: 43.74,
    y2: 61.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint15_linear_33134_63673",
    x1: 107.195,
    y1: 68.87,
    x2: 39.745,
    y2: 33.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint16_linear_33134_63673",
    x1: 126.64,
    y1: 8.087,
    x2: 21.63,
    y2: 36.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint17_linear_33134_63673",
    x1: 31.129,
    y1: 58.873,
    x2: 28.363,
    y2: 59.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint18_linear_33134_63673",
    x1: 8.037,
    y1: 42.277,
    x2: -0.46,
    y2: 45.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint19_linear_33134_63673",
    x1: 127.577,
    y1: 11.567,
    x2: 22.566,
    y2: 39.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint20_linear_33134_63673",
    x1: 5.351,
    y1: 60.727,
    x2: 14.233,
    y2: 60.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint21_linear_33134_63673",
    x1: -0.417,
    y1: 54.43,
    x2: 1.258,
    y2: 55.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint22_linear_33134_63673",
    x1: 18.295,
    y1: 69.396,
    x2: 23.592,
    y2: 69.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint23_linear_33134_63673",
    x1: 30.254,
    y1: 63.927,
    x2: 46.612,
    y2: 63.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint24_linear_33134_63673",
    x1: 77.269,
    y1: 35.308,
    x2: 92.916,
    y2: 35.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint25_linear_33134_63673",
    x1: 72.397,
    y1: 46.256,
    x2: 92.291,
    y2: 46.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint26_linear_33134_63673",
    x1: 83.745,
    y1: 38.312,
    x2: 106.544,
    y2: 40.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint27_linear_33134_63673",
    x1: 83.619,
    y1: 39.614,
    x2: 106.418,
    y2: 41.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint28_linear_33134_63673",
    x1: 83.386,
    y1: 41.457,
    x2: 106.453,
    y2: 43.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint29_linear_33134_63673",
    x1: 83.591,
    y1: 39.452,
    x2: 106.648,
    y2: 41.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint30_linear_33134_63673",
    x1: 83.961,
    y1: 36.061,
    x2: 106.761,
    y2: 38.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint31_linear_33134_63673",
    x1: 83.966,
    y1: 36.021,
    x2: 106.765,
    y2: 38.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint32_linear_33134_63673",
    x1: 88.49,
    y1: 37.292,
    x2: 89.258,
    y2: 40.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint33_linear_33134_63673",
    x1: 88.323,
    y1: 38.21,
    x2: 87.852,
    y2: 40.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint34_linear_33134_63673",
    x1: 61.341,
    y1: 88.245,
    x2: 35.287,
    y2: 81.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B38F85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint35_linear_33134_63673",
    x1: 36.379,
    y1: 62.046,
    x2: 52.39,
    y2: 72.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint36_linear_33134_63673",
    x1: 40.832,
    y1: 77.001,
    x2: 48.514,
    y2: 59.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint37_linear_33134_63673",
    x1: 45.02,
    y1: 71.485,
    x2: 44.59,
    y2: 62.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint38_linear_33134_63673",
    x1: 42.516,
    y1: 76.839,
    x2: 39.474,
    y2: 78.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint39_linear_33134_63673",
    x1: 45.367,
    y1: 65.407,
    x2: 45.367,
    y2: 87.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint40_linear_33134_63673",
    x1: 44.855,
    y1: 65.194,
    x2: 44.855,
    y2: 87.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint41_linear_33134_63673",
    x1: 39.938,
    y1: 57.347,
    x2: 43.373,
    y2: 56.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint42_linear_33134_63673",
    x1: 41.594,
    y1: 57.934,
    x2: 46.328,
    y2: 56.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint43_linear_33134_63673",
    x1: 39.796,
    y1: 69.536,
    x2: 35.794,
    y2: 66.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "update-membership_svg__paint44_linear_33134_63673",
    x1: 41.229,
    y1: 71.663,
    x2: 40.799,
    y2: 62.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C6E"
  })))));
}
export default __webpack_public_path__ + "static/media/update-membership.81812027.svg";
export { SvgUpdateMembership as ReactComponent };